<template>
  <div class="card">
    <h5 class="card-header bg-primary text-white">Request for Contact</h5>
    <div class="card-body">
      <div class="col-12">
        <div class="row">
          <h5 class="col-12 font-weight-bold"><span class="text-danger">Action Required:</span> Contact the employee for further discussion.</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: Boolean,
    report: Object,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";
</style>
